module.exports = __webpack_public_path__ + "static/21-08-26_12-17-22_7533-d268fd355b03ec87fa5693b5e0ff0547.png";